import { Image } from "react-bootstrap";
import arrow from "../assets/images/arrow-up.svg";

function ButtonArrow () {
    return (
        <Image style={{ filter: 'invert(100%)' }} src={arrow} />
    )
}

export default ButtonArrow;
